import { Pipe, PipeTransform } from '@angular/core';
import { Menu } from '../../../models/menu/menu';
import { SectionWithProducts } from '../../../models/menu/section/section-with-products';

@Pipe({
  name: 'getSectionBorderRadius',
  standalone: false
})
export class GetSectionBorderRadiusPipe implements PipeTransform {
  transform(menu: Menu, section: SectionWithProducts): string {
    return section?.getBorderRadius(menu);
  }
}
